import { useAxios } from '../utils/axiosConfig';
import { useNotification } from "../contexts/NotificationContext";
import config from '../contexts/ConfigContext';
import { AuditEntriesModel } from 'components/History Tracking/AuditComponent';

export interface FilterModel {
    Tags: string[];
    WhereType: number;
}

export interface EntityModel {
    ProjectId: number;
    ObjectIds: number[];
}

export interface EntityLabelsModel {
    ProjectId: number;
    TargetId: number[];
    ObjectIds: number[];
}

export class EntityService {

    axios = useAxios();

    // Define the notification hook
    notification = useNotification();

    // Call the API to get the filters for the current user and project
    async GetMyProjectEntitiesFilter(): Promise<FilterModel> {
        try {
            const response = await this.axios.get(`${config.API_URL}/api/ProjectEntities/GetMyFilter`);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching filters: ' + error, 'error');
            console.error('Error fetching filters:', error);
            return { Tags: [], WhereType: 1 };
        }
    }
    // Call the API to update the filters for the current user and project
    async UpdateMyProjectEntitiesFilter(filterModel: FilterModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectEntities/UpdateMyFilter`, filterModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching entities: ' + error, 'error');
            console.error('Error fetching entities:', error);           
        }
    }

    // Call the API to add entities to the current project
    async AddEntitiesToProject(entityModel: EntityModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectEntities/AddEntityToProject`, entityModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error add entities: ' + error, 'error');
            console.error('Error add entities:', error);           
        }
    }

    // Call the API to remove entities from the current project
    async RemoveEntitiesFromProject(entityModel: EntityModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectEntities/RemoveEntityFromProject`, entityModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error remove entities: ' + error, 'error');
            console.error('Error remove entities:', error);
            
        }
    }

    // Call the API to get the filters for the current user and project
    async GetMyEntitiesFilter(): Promise<FilterModel> {
        try {
            const response = await this.axios.get(`${config.API_URL}/api/Entities/GetMyFilter`);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching filters: ' + error, 'error');
            console.error('Error fetching filters:', error);   
            return { Tags: [], WhereType: 1 };        
        }
    }
    // Call the API to update the filters for the current user and project
    async UpdateMyEntitiesFilter(filterModel: FilterModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/Entities/UpdateMyFilter`, filterModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error fetching entities: ' + error, 'error');
            console.error('Error fetching entities:', error);           
        }
    }

    // Call the API to add labels to entities
    async AddLabelsToEntities(entityLabelsModel: EntityLabelsModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectEntityLabels/AddLabelToEntity`, entityLabelsModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error add labels: ' + error, 'error');
            console.error('Error add labels:', error);           
        }
    }

    // Call the API to remove labels from entities
    async RemoveLabelsFromEntities(entityLabelsModel: EntityLabelsModel): Promise<void> {
        try {
            const response = await this.axios.post(`${config.API_URL}/api/ProjectEntityLabels/RemoveLabelFromEntity`, entityLabelsModel);
            return response.data;
        } catch (error) {
            // Handle error
            this.notification.showNotification('Error remove labels: ' + error, 'error');
            console.error('Error remove labels:', error);            
        }
    }

    async GetAudit(entityId: number): Promise<AuditEntriesModel[]>{
        try {
            const response = await this.axios.get(config.API_URL + "/api/Entities/GetAudit?entityId=" + entityId);
            return response.data;
        }
        catch (error: any) {
            this.notification.showNotification("Error getting entity audit history: " + error, 'error');
            console.error("Error getting entity audit history: ", error);
            return {} as AuditEntriesModel[];
        }
    }
}